import { getDoc } from 'firebase/firestore/lite'
import refs from '../refsLite'

export async function getAssignmentDetail(assignmentDetailId) {
  const assignmentDetailDoc = await getDoc(
    refs.assignmentDetail(assignmentDetailId),
  )
  return assignmentDetailDoc.data() || null
}
